import { useState } from "react";
import { Form } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../../axios/axios";
import { message } from "antd";
import { adminConfig } from "../../../../utils/adminConfig";

export default function AddPreferredPartners() {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState("");
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [desc, setDesc] = useState("");

  const addCalendar = async (e) => {
    e.preventDefault();

    if (!file) {
      message.error("file not found");
      return;
    }

    setLoading(true);
    let data = new FormData();

    data.append("image", file);
    data.append("title", title);
    data.append("url", url);
    data.append("desc", desc);

    await axios
      .post(`/add-preferred-partners`, data, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          setFile("");
          setTitle("");
          setUrl("");
          setDesc("");
          message.success("Partner Added Successfully");
        } else {
          message.error("failed adding Image");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        message.error("Something Went Wrong");
      });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <Form onSubmit={addCalendar}>
                <div className="user_added resources_p">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Enter Heading</Form.Label>
                    <Form.Control
                      type="text"
                      value={title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                      }}
                      placeholder="Enter Heading"
                      className="text_link"
                      required
                    />
                  </Form.Group>
                  <div className="upload_pdf">
                    <h3>
                      Upload Image <br />
                      <small>(Image resolution should be 1024*680)</small>
                    </h3>
                    <div className="upload_btn_wrapper">
                      <button className="btn_bulk">
                        <span className="cert_bulkks">
                          <img src={Image} alt="" />
                        </span>
                        {file ? (
                          file.name
                        ) : (
                          <>
                            Upload Image
                            <input
                              type="file"
                              name="myfile"
                              onChange={(e) => {
                                setFile(e.target.files[0]);
                              }}
                              required
                            />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Enter URL</Form.Label>
                    <Form.Control
                      type="text"
                      value={url}
                      onChange={(e) => {
                        setUrl(e.target.value);
                      }}
                      placeholder="Enter URL"
                      className="text_link"
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Enter Description</Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      rows={5}
                      value={desc}
                      onChange={(e) => {
                        setDesc(e.target.value);
                      }}
                      placeholder="Enter Description"
                      className="text_link"
                      required
                    />
                  </Form.Group>

                  <div className="sub_but">
                    <button type="submit" className="add_but submit_buttt mt-0">
                      Submit
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}
